import React from "react";

const Video = props => {

  return (
    <React.Fragment>

        {/* <!--========================== */}
        {/* Video Section */}
        {/* ============================--> */}

        <section id="video" className="text-center wow fadeInUp">
          <div className="overlay">
            <div className="container-fluid container-full">

              <div className="row">
                <a href="/" className="js-modal-btn play-btn" data-video-id="s22ViV7tBKE"> </a>
              </div>

            </div>
          </div>
        </section>
      </React.Fragment>
      );
    }
export default Video;
